import { arrowGenerator } from '../../helpers'
import { StyleFn } from '..'

export const Popover: StyleFn = ({ color, font, elevation }) => {
  const backgroundColor = color.getModalValues(color.background.primary)
  const { root: arrowRoot, arrow } = arrowGenerator(8, backgroundColor)

  return {
    root: {
      position: 'absolute',
      fontSize: font.size.small,
      lineHeight: font.lineheight.small,
      backgroundColor,
      color: color.type === 'light' ? color.palette.coolgrey[90] : color.palette.white,
      borderRadius: '3px',
      boxShadow: '0 2px 8px 0 rgba(0,0,0,0.20)',
      // FIXME not sure this is needed at all, and it makes Combobox multiple list items fuzzy in chrome/macos
      // opacity: 0.99, // see https://philipwalton.com/articles/what-no-one-told-you-about-z-index/
      zIndex: elevation.zindex.popover,
      ...arrowRoot,
    },
    arrow,
    arrow_center: {
      marginLeft: `calc(50% - 4px)`,
    },
  }
}
